(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /*
   * Natural numerical sorting for all model series.
   *
   * Examples:
   * A1, A2, A3 ... A10, A11
   * D1, D2, D3 ... D41, D42, D53
   * G-1, G-2, G-3 ... G-58, G-59
   *
   * Cards are not moved in the DOM.
   * Only CSS order is changed, so Horizon infinite scroll remains intact.
   */

  const modelTitleCollator = new Intl.Collator(undefined, {
    numeric: true,
    sensitivity: 'base'
  });

  function getModelSortData(title) {
    const cleanTitle = String(title || '').trim();

    const modelMatch = cleanTitle.match(
      /^([a-z]+)\s*[-–—]?\s*(\d+)/i
    );

    if (!modelMatch) {
      return {
        hasModelNumber: false,
        series: '',
        number: Number.MAX_SAFE_INTEGER,
        title: cleanTitle
      };
    }

    return {
      hasModelNumber: true,
      series: modelMatch[1].toUpperCase(),
      number: Number.parseInt(modelMatch[2], 10),
      title: cleanTitle
    };
  }

  function compareProductCards(cardA, cardB) {
    const dataA = getModelSortData(cardA.dataset.productTitle);
    const dataB = getModelSortData(cardB.dataset.productTitle);

    if (dataA.hasModelNumber && dataB.hasModelNumber) {
      const seriesComparison = modelTitleCollator.compare(
        dataA.series,
        dataB.series
      );

      if (seriesComparison !== 0) {
        return seriesComparison;
      }

      if (dataA.number !== dataB.number) {
        return dataA.number - dataB.number;
      }
    } else if (dataA.hasModelNumber !== dataB.hasModelNumber) {
      return dataA.hasModelNumber ? -1 : 1;
    }

    return modelTitleCollator.compare(dataA.title, dataB.title);
  }

  function sortProductCardsNaturally(scope = document) {
    const resultsLists = [];

    if (scope instanceof Element && scope.matches('results-list')) {
      resultsLists.push(scope);
    }

    if (scope.querySelectorAll) {
      resultsLists.push(...scope.querySelectorAll('results-list'));
    }

    resultsLists.forEach((resultsList) => {
      const cards = Array.from(
        resultsList.querySelectorAll(
          '.product-grid__item[data-product-title]'
        )
      );

      if (cards.length < 2) return;

      const cardsByParent = new Map();

      cards.forEach((card) => {
        const parent = card.parentElement;

        if (!parent) return;

        if (!cardsByParent.has(parent)) {
          cardsByParent.set(parent, []);
        }

        cardsByParent.get(parent).push(card);
      });

      cardsByParent.forEach((parentCards) => {
        const sortedCards = [...parentCards].sort(compareProductCards);

        sortedCards.forEach((card, index) => {
          /*
           * Negative values keep every product card before Horizon’s
           * infinite-scroll controls without changing the DOM structure.
           */
          card.style.order = String(-10000 + index);
        });
      });
    });
  }

  let modelSortScheduled = false;

  function scheduleModelSorting() {
    if (modelSortScheduled) return;

    modelSortScheduled = true;

    requestAnimationFrame(() => {
      modelSortScheduled = false;
      sortProductCardsNaturally(document);
    });
  }

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      scheduleModelSorting();

      const productResultsObserver = new MutationObserver((mutations) => {
        const productsAdded = mutations.some((mutation) => {
          return Array.from(mutation.addedNodes).some((node) => {
            if (!(node instanceof Element)) return false;

            return (
              node.matches('.product-grid__item[data-product-title]') ||
              node.matches('results-list') ||
              node.querySelector(
                '.product-grid__item[data-product-title]'
              ) !== null
            );
          });
        });

        if (productsAdded) {
          scheduleModelSorting();
        }
      });

      productResultsObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    },
    { once: true }
  );

  document.addEventListener('shopify:section:load', () => {
    scheduleModelSorting();
  });

  } catch(e) { console.error(e); }
})();
})();
